module.exports = __webpack_public_path__ + "img/ico-incluido.3a08288b.svg";